<template>
	<div>
		<v-card flat class="pa-1">
			<v-toolbar flat color="#FFF" short>
				<v-toolbar-title v-if="ativarTelaItens == 0">
					Análise de Rentabilidade
				</v-toolbar-title>
				<v-toolbar-title v-else>
					<span style="font-weight: 400">
						{{ dadosFornecedor.idfornecedor }} -
						{{ dadosFornecedor.razao_social }}
					</span>
					<span v-if="dadosFornecedor.filial > 0">
						/ Filial: {{ dadosFornecedor.filial }}
					</span>
					<span v-else> 
						/ {{ grupo[0].descricao }}
					</span>
					<span> 
						/ Período Analisado: {{ dadosFornecedor.qtde_dias }} dias
					</span>
				</v-toolbar-title>
			</v-toolbar>
			<v-tabs centered v-model="ativarTelaItens">
				<v-tab  @click="dadosFornecedor={}">
					<v-icon left>mdi-clipboard-list-outline</v-icon>
					ANÁLISE POR FORNECEDORES
				</v-tab>
				<v-tab v-if="dadosFornecedor.idfornecedor">
					<v-icon left>mdi-format-list-bulleted-square</v-icon>
					ANÁLISE POR ITENS DO FORNECEDOR
				</v-tab>

				<v-tab-item class="ma-0">
					<v-card flat>
						<v-card-text class="pa-0">
							<rentabilidade-fornecedores
								@telaItensFornecedor="dadosFornecedor = $event"
								@atualizarDados="atualizarDados += $event"
							></rentabilidade-fornecedores>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item class="ma-0">
					<v-card flat>
						<v-card-text class="pa-0">
							<rentabilidade-fornecedor
								:dadosFornecedor="dadosFornecedor"
								:atualizarDados="atualizarDados"
							></rentabilidade-fornecedor>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</v-card>
	</div>
</template>

<script>
import rentabilidadeFornecedores from "./RentabilidadeFornecedores";
import rentabilidadeFornecedor from "./RentabilidadeFornecedor";
import {mapGetters} from "vuex";

export default {
	components: {
		rentabilidadeFornecedores,
		rentabilidadeFornecedor,
	},

	data() {
		return {
			ativarTelaItens: 0,
			dadosFornecedor: {},
			atualizarDados: 0,
			grupo: {}
		};
	},

    computed: {
        ...mapGetters({
			grupos: "usuario/getGrupos"
        }),
	},

	watch: {
		atualizarDados() {
			this.ativarTelaItens = 1;
			this.grupo = this.grupos.filter(grupo => grupo.id == this.dadosFornecedor.grupo)
		},
	},

	created() {
		this.Helpers.verificarToken();
	},
};
</script>
